import { useNavigate } from '@reach/router'
import { isNil } from 'lodash'
import React, { type FC } from 'react'
import { t } from 'i18next'
import { useDeletePathway } from '../../hooks/useDeletePathway'
import { AlertDialog, Icon } from '@awell-health/design-system'

interface DeletePathwayModalProps {
  onClose: () => void
  careflow_id: string | undefined
  patient_id?: string
  redirectToUri?: string | undefined
  patientName?: string
  careflowName?: string
}

export const DeletePathwayModal: FC<DeletePathwayModalProps> = ({
  onClose,
  careflow_id,
  patient_id,
  redirectToUri,
  patientName,
  careflowName
}) => {
  const { deletePathway } = useDeletePathway(patient_id)
  const navigate = useNavigate()

  const handleDeletePathway = async (): Promise<void> => {
    if (!isNil(careflow_id)) {
      await deletePathway({ pathway_id: careflow_id })
      onClose()
      if (!isNil(redirectToUri)) {
        void navigate(redirectToUri)
      }
    }
  }

  return (
    <AlertDialog
      icon={<Icon icon="RiDeleteBinLine" color="red" size={24} />}
      title="Are you sure you want to delete this care flow?"
      text={
        patientName
          ? t('delete_patient_pathway_heading_personalized', {
              patientName,
              careflowName
            })
          : t('delete_patient_pathway_heading')
      }
      button={{
        label: t('delete'),
        buttonAction: handleDeletePathway
      }}
      secondaryButton={{
        label: t('cancel'),
        buttonAction: onClose
      }}
    />
  )
}
